import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getGirdColumns, getGirdRows } from "../functions";

import { ParticipantView } from "../../base/participants";
import { StyledLayoutContainer } from "../styled";

function HostFilm({ layoutWidth, layoutHeight,
    hostParticipant
}) {
    const [gridStyle, setGridStyle] = useState();

    useEffect(() => {
        const columns = getGirdColumns(1);
        const rows = getGirdRows(1);
        
        if (document.getElementsByClassName("arrow")?.length > 0) {
            layoutWidth = layoutWidth - 60;
        };
        const initWidth = layoutWidth / columns;
        const initHeight = layoutHeight / rows;

        let width = initWidth;
        let height = ((9 * width) / 16);

        if ((Math.floor(initHeight/height) < rows) && (initHeight < height)) {
            height = initHeight;
            width = ((16 * height) / 9) ;
        }

        setGridStyle({width: `${width}px`, height: `${height}px`});
    }, [layoutWidth, layoutHeight]);
    
    return (
        <>                      
            { [...hostParticipant].map(hostId => {
                return (
                    <StyledLayoutContainer key={hostId} isLocal={true} className={`item item_true`} style={gridStyle}> 
                        <ParticipantView participantId={hostId} />
                    </StyledLayoutContainer>
                )
            }) }
        </>
    );
}

function _mapStateToProps(state) {
    const { hostParticipant } = state['features/base/participants'];
    const { layoutWidth, layoutHeight } = state['features/video-layout-mode'];
    
    return {
        layoutWidth, layoutHeight,
        hostParticipant
    };
}

export default connect(_mapStateToProps)(HostFilm);
